import { OrderSummaryInterface } from "@/interface/order.inteface";
import { OrderSummaryType } from "@/types/orders";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import { CustomerPhoneInterface, CustomerPhoneModule } from "@/modules/customer/phones";
import { OrderOptionsInterface } from "@/interface/business/order.interface";
import { OrderOption } from "@/modules/location";

export default class OrderSummary implements OrderSummaryInterface {
  id: string;
  issuer_id: string;
  name: string;
  ticket_number: string;
  creation_time: string;
  status: string;
  total_amount: number;
  update_time: string;
  creator: string;
  failedTime: string = "";
  isFailed: boolean = false;
  isRetrying: boolean = false;
  location_id: string = "";
  transaction_id: string = "";
  payment_status: string = "";
  source: string = "";

  sale_id: string = "";
  address: any = "";
  phone: CustomerPhoneInterface;
  customer_name: any = "";
  order_option: OrderOptionsInterface;

  constructor(data: OrderSummaryType) {
    this.id = data.id;
    this.issuer_id = data.issuer_id;
    this.name = data.name;
    this.ticket_number = data.ticket_number;
    this.creation_time = data.creation_time;
    this.update_time = data.update_time;
    this.status = data.status;
    this.total_amount = data.total_amount;
    this.creator = data.creator;
    this.location_id = data.location_id || "";
    this.isFailed = data?.isFailed || false;
    this.failedTime = data?.failedTime || "";
    this.sale_id = data?.sale_id || "";
    this.transaction_id = data?.transaction_id || "";
    this.payment_status = data?.payment_status || "";
    this.source = data?.source || ""; // || ORDER_SOURCE.CALLCENTER_TEXT;

    this.customer_name = data?.customer_name || data?.sale?.customer || null;
    this.address = data?.address || data?.sale?.customer?.addresses || data?.sale?.customer?.["address"] || "";

    this.phone = new CustomerPhoneModule(
      data?.phone || data?.sale?.customer?.phone_numbers?.[0] || data?.sale?.customer?.["phone"]
    );
    this.order_option = new OrderOption(data.order_option || data?.sale?.["order_option"]);
  }

  /**
   * Price package
   * @return {any}
   */
  public pricePackage(): any {
    const { currency = "" } = Storage.get(StorageConstants.BUSINESS);
    let price = this.total_amount || 0;
    if (!!price) {
      price = price / 1000;
      price.toFixed(3);
    }
    return `${price} ${currency}`;
  }

  /**
   * Agent Short Name
   * @return {string}
   */
  public creatorShortName(): string {
    const name = this.creator["name"] || this.creator;
    name.split(" ");
    return `${name[0]?.charAt(0)}${name[1]?.charAt(0)}`;
  }

  /**
   * Agent name
   * @return {string}
   */
  public creatorName(): string {
    return this.creator["name"] || this.creator;
  }

  /**
   * Created At Formatter
   * @return {string}
   */
  public createdAt(fromNow: boolean = false): string {
    const creation_time = window.moment(this.creation_time);
    if (fromNow) {
      return creation_time.fromNow();
    }
    return creation_time.format("YYYY-MM-DD HH:mm");
  }

  /**
   * Created At Formatter
   * @return {string}
   */
  public createdAtDate(): string {
    const creation_time = window.moment(this.creation_time);
    return creation_time.format("YYYY-MM-DD");
  }

  /**
   * Created At Formatter
   * @return {string}
   */
  public createdAtTime(): string {
    const creation_time = window.moment(this.creation_time);
    return creation_time.format("hh:mm:ss A");
  }

  /**
   * UpdateAt At Formatter
   * @return {string}
   */
  public updatedAt(fromNow: boolean = false): string {
    const update_time = window.moment(this.update_time);
    if (fromNow) {
      return update_time.fromNow();
    }
    return update_time.format("YYYY-MM-DD HH:mm");
  }

  /**
   * Address formatted
   * @return {string}
   */
  public getAddress(): string {
    if (window._.isEmpty(this.address)) {
      return "";
    }

    if ("string" === typeof this.address) {
      return this.address.trim();
    }

    let selectedAddress = this.address;
    if (this.address?.length) {
      const index = this.address.findIndex((address) => address.selected);
      selectedAddress = this.address[index];
      return `${selectedAddress?.city?.en} ${selectedAddress?.area?.en} `;
    }

    return `${selectedAddress?.city?.name_en} ${selectedAddress?.area?.name_en} `;
  }

  /**
   * Customer Name
   * @return {string}
   */
  public getCustomerName(): string {
    if ("string" === typeof this.customer_name) {
      return this.customer_name;
    }

    return `${this.customer_name?.first_name} ${this.customer_name?.last_name || ""} `;
  }

  updateStatus(status) {
    this.status = status;
  }

  /**
   * get Branch Name
   * @return string
   */
  public getBranchName(): string {
    const branches = Storage.get(StorageConstants.LOCATIONS);
    return branches.find((b) => b.id === this.location_id)?.name || "";
  }
}
